const LOG_ENDPOINT = "https://script.google.com/macros/s/AKfycbw0NQ3j-qRcxN6iPili32Cnq9jBGOjc_TxW4CEmGzyi0xM6AMRDfG9wDIOe46sHIOdeSw/exec";

export function affClick(event) {
  try {
    const dest =
      event?.currentTarget?.href ||
      event?.target?.href ||
      "";

    if (!dest) return;

    const payloadStr = JSON.stringify({ dest });

    const ok =
      typeof navigator.sendBeacon === "function" &&
      navigator.sendBeacon(
        LOG_ENDPOINT,
        new Blob([payloadStr], { type: "text/plain" }) 
      );

    if (!ok) {
      fetch(LOG_ENDPOINT, {
        method: "POST",
        mode: "no-cors",
        keepalive: true,
        body: payloadStr, 
      }).catch(() => {});
    }
  } catch {
    // ログ送信失敗は無視して遷移を優先
  }
}